import React, { useEffect, useState } from "react";
import axios from "axios";
import "react-datepicker/dist/react-datepicker.css";
import * as apiMethods from "../res/apiMethods.js";

import VisibilityIcon from "@mui/icons-material/Visibility";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import LockResetIcon from "@mui/icons-material/LockReset";
import PersonAddIcon from "@mui/icons-material/PersonAdd";
import SearchIcon from "@mui/icons-material/Search";
import ShieldIcon from "@mui/icons-material/Shield";
import CircularProgress from "@mui/material/CircularProgress";
import { useFormik } from "formik";
import TextField from "@mui/material/TextField";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import Button from "@mui/material/Button";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import * as yup from "yup";
import Swal from "sweetalert2";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import AccessDenied from "./accessDenied.jsx";

const Users = () => {
  const [props, setProps] = React.useState({
    usersData: [],
    createDialog: false,
    update: false,
    userId: "",
    isAdmin: null, 
  });
  const [passwordDialog, setPasswordDialog] = React.useState({
    open: false,
    usrId: "",
    username: "",
  });
  const [passwordForm, setPasswordForm] = React.useState({
    password: "",
    confirmPassword: "",
  });
  const [searchTerm, setSearchTerm] = useState('');

  const isComplemento360 = React.useMemo(() => {
    try {
      const username = window.sessionStorage.getItem("username");
      const token = window.sessionStorage.getItem("localToken");
      if (!username || !token) return false;
      if (username !== "complemento360") return false;
      const payload = JSON.parse(atob(token.split(".")[1]));
      return payload.roleId === 1;
    } catch {
      return window.sessionStorage.getItem("username") === "complemento360";
    }
  }, [props.isAdmin]);

  const validationSchema = yup.object().shape({
    username: yup.string().required("El nombre de usuario es requerido"),
    password: yup.string().required("La contraseña es requerida"),
    roleId: yup.string().required("El rol es requerido"),
  });

  const formik = useFormik({
    validationSchema: validationSchema,
    onSubmit: (values) => {
      
    },
    initialValues: {
      username: "",
      password: "",
      roleId: "2",
    },
  });

  const setState = (value) => {
    setProps((prevState) => ({ ...prevState, ...value }));
  };

  const loadUsers = async () => {
    try {
      let actUsrToken = window.sessionStorage.getItem("localToken");
      let usersResponse = await axios.get(apiMethods.GET_USUARIO_ALL, {
        headers: { Authorization: actUsrToken }
      });
      
      if (usersResponse.data.code === 0 && usersResponse.data.clients) {
        setState({ usersData: usersResponse.data.clients });
        return true;
      } else {
        setState({ usersData: [] });
        return false;
      }
    } catch (error) {
      console.error("Error al cargar usuarios:", error);
      setState({ usersData: [] });
      
      if (error.response?.status === 403) {
        toast.error("No tienes permisos para acceder a esta sección");
      }
      
      return false; 
    }
  };

  useEffect(() => {
    (async () => {
      document.title = "Usuarios";
      const isAllowed = await loadUsers();
      
      if (isAllowed) {
        setState({ isAdmin: true });
      } else {
        setState({ isAdmin: false });
      }
    })();
  }, []);

  const openPasswordDialog = (row) => {
    setPasswordDialog({ open: true, usrId: row.usrId, username: row.username });
    setPasswordForm({ password: "", confirmPassword: "" });
  };

  const closePasswordDialog = () => {
    setPasswordDialog({ open: false, usrId: "", username: "" });
    setPasswordForm({ password: "", confirmPassword: "" });
  };

  const handlePasswordChange = async (e) => {
    if (e) e.preventDefault();
    const { password, confirmPassword } = passwordForm;
    if (!password || !confirmPassword) {
      toast.error("Por favor complete ambos campos de contraseña");
      return;
    }
    if (password.length < 8) {
      toast.error("La contraseña debe tener al menos 8 caracteres");
      return;
    }
    if (password !== confirmPassword) {
      toast.error("Las contraseñas no coinciden");
      return;
    }
    try {
      const actUsrToken = window.sessionStorage.getItem("localToken");
      const response = await axios.patch(
        apiMethods.PATCH_USUARIO_PASSWORD + passwordDialog.usrId,
        { password },
        { headers: { Authorization: actUsrToken } }
      );
      if (response.data.code === 0) {
        toast.success(`Contraseña de "${passwordDialog.username}" actualizada con éxito`);
        closePasswordDialog();
      } else {
        toast.error(response.data.message || "Error al actualizar la contraseña");
      }
    } catch (error) {
      const msg = error.response?.data?.message || error.message || "Error al actualizar la contraseña";
      if (error.response?.status === 403) {
        toast.error("Acceso denegado. Solo complemento360 puede cambiar contraseñas.");
      } else {
        toast.error(msg);
      }
    }
  };

  const roles = ["Administrador", "Usuario"];

  const getRoleName = (roleId) => {
    if (!roleId || !roles.length) return '-';
    const roleIndex = roleId - 1;
    return roles[roleIndex] || 'Rol desconocido';
  };

  const createUser = async (e) => {
  e.preventDefault();
  let valid = true;
  for (let val in formik.values) {
    if (formik.values[val] === "") {
      valid = false;
      break;
    }
  }
  if (valid) {
    let actUsrToken = window.sessionStorage.getItem("localToken");
    
    // Crear objeto limpio con solo los valores necesarios
    const userData = {
      username: formik.values.username,
      password: formik.values.password,
      roleId: formik.values.roleId
    };
    
    let signUpResponse = await axios.post(
      apiMethods.CREATE_USUARIO, 
      userData,  // ← Cambiar esta línea
      { headers: { Authorization: actUsrToken } }
    );
    
    if (signUpResponse.data.code == 0) {
      toast.success("Usuario creado con éxito");
      closeCreateDialog();
      loadUsers();
    } else {
      toast.error(signUpResponse.data.message || "Error al crear el usuario");
    }
  }
};

  const updateUser = async (e) => {
    e.preventDefault();
    let valid = true;
    let userData = { ...formik.values };
    delete userData.password;
    for (let val in userData) {
      if (userData[val] === "") {
        valid = false;
        break;
      }
    }
    if (valid) {
      // El backend ahora maneja la validación de username existente
      let actUsrToken = window.sessionStorage.getItem("localToken");
      let patchResponse = await axios.patch(
        apiMethods.PATCH_USUARIO_ID + props.userId,
        userData,
        { headers: { Authorization: actUsrToken } }
      );
      
      if (patchResponse.data.code == 0) {
        toast.success("Usuario actualizado con éxito");
        closeCreateDialog();
        loadUsers();
      } else {
        toast.error(patchResponse.data.message || "Error al actualizar el usuario");
      }
    } else {
      toast.error("Por favor complete todos los campos");
    }
  };

  const onError = (e) => {
    e.preventDefault();
    for (let error in formik.errors) {
      toast.error(formik.errors[error]);
    }
  };

  const openCreateDialog = (formData) => {
    if (formData) {
      for (let val in formData) {
        formik.setFieldValue(val, formData[val]);
      }
    }
    setState({ createDialog: true });
  };

  const closeCreateDialog = () => {
    formik.resetForm();
    setState({ createDialog: false, update: false });
  };

  // ─── Filtrado de usuarios por búsqueda ───
  const filteredUsers = props.usersData.filter(user =>
    user.username?.toLowerCase().includes(searchTerm.toLowerCase()) ||
    getRoleName(user.roleId)?.toLowerCase().includes(searchTerm.toLowerCase())
  );

  // ─── Estilo compartido para botones de acción en la tabla ───
  const actionBtnStyle = {
    background: 'rgba(255, 255, 255, 0.7)',
    border: '1px solid rgba(15, 23, 42, 0.1)',
    borderRadius: '8px',
    padding: '0.35rem 0.5rem',
    cursor: 'pointer',
    color: '#475569',
    display: 'flex',
    alignItems: 'center',
    transition: 'all 0.15s ease',
    fontFamily: 'inherit'
  };
  
  if (props.isAdmin === false) {
    return <AccessDenied />;
  }

  if (props.isAdmin === null) {
    return (
      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: '60vh', gap: '1rem' }}>
        <CircularProgress sx={{ color: '#D71920' }} />
        <p style={{ color: '#667085', fontSize: '0.9rem', fontWeight: 500 }}>Cargando usuarios...</p>
      </div>
    );
  }

  return window.sessionStorage.getItem("localToken") ? (
    <React.Fragment>
      <ToastContainer />
      <div style={{ display: 'flex', flexDirection: 'column', gap: '2rem', maxWidth: '1200px', margin: '0 auto' }}>
        {/* Header de la sección */}
        <div className="section-header">
          <div className="title-group">
            <h1>Gestión de Usuarios & Roles</h1>
            <p>Control de accesos, perfiles de seguridad y asignación de contraseñas</p>
          </div>
          <button
            type="button"
            className="btn-mobilia-primary"
            onClick={() => openCreateDialog()}
          >
            <PersonAddIcon style={{ fontSize: '1.1rem' }} /> Nuevo Usuario
          </button>
        </div>

        {/* Contenedor Principal */}
        <div className="glass-panel" style={{ padding: '1.85rem', display: 'flex', flexDirection: 'column', gap: '1.35rem' }}>
          {/* Barra de Búsqueda */}
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: '1rem', flexWrap: 'wrap' }}>
            <div style={{ position: 'relative', width: '320px' }}>
              <SearchIcon style={{ position: 'absolute', left: '12px', top: '50%', transform: 'translateY(-50%)', color: '#94a3b8', fontSize: '1.15rem' }} />
              <input
                type="text"
                placeholder="Buscar por usuario o rol..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                style={{
                  width: '100%',
                  padding: '0.55rem 1rem 0.55rem 2.5rem',
                  borderRadius: '12px',
                  border: '1px solid rgba(15, 23, 42, 0.12)',
                  background: 'rgba(255, 255, 255, 0.7)',
                  backdropFilter: 'blur(8px)',
                  fontSize: '0.86rem',
                  outline: 'none',
                  transition: 'border-color 0.2s ease',
                  fontFamily: 'inherit'
                }}
              />
            </div>

            <div style={{ fontSize: '0.8rem', color: '#64748b' }}>
              Mostrando <strong>{filteredUsers.length}</strong> de {props.usersData.length} usuarios
            </div>
          </div>

          {/* Tabla de Usuarios */}
          <div className="modern-table-container">
            <table className="modern-table">
              <thead>
                <tr>
                  <th>Usuario</th>
                  <th>Rol / Nivel</th>
                  <th>Acciones</th>
                </tr>
              </thead>
              <tbody>
                {filteredUsers.length > 0 ? (
                  filteredUsers.map((user) => (
                    <tr key={user._id}>
                      <td>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '0.65rem' }}>
                          <div style={{
                            width: '34px',
                            height: '34px',
                            borderRadius: '9px',
                            background: 'rgba(203, 16, 22, 0.08)',
                            color: '#cb1016',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            fontWeight: 700,
                            fontSize: '0.88rem',
                            flexShrink: 0
                          }}>
                            {user.username?.charAt(0).toUpperCase() || '?'}
                          </div>
                          <span style={{ fontWeight: 600, color: '#090d16' }}>{user.username}</span>
                        </div>
                      </td>
                      <td>
                        <span className={user.roleId === 1 ? "badge-pill-red" : "badge-pill-navy"}>
                          <ShieldIcon style={{ fontSize: '0.8rem' }} /> {getRoleName(user.roleId)}
                        </span>
                      </td>
                      <td>
                        <div style={{ display: 'flex', gap: '0.4rem' }}>
                          {/* Editar */}
                          <button
                            title="Ver / editar usuario"
                            style={actionBtnStyle}
                            onClick={() => {
                              setState({ update: true, userId: user.usrId });
                              openCreateDialog({
                                username: user.username,
                                roleId: String(user.roleId),
                              });
                            }}
                            onMouseEnter={(e) => { e.currentTarget.style.color = '#090d16'; e.currentTarget.style.borderColor = 'rgba(15, 23, 42, 0.25)'; }}
                            onMouseLeave={(e) => { e.currentTarget.style.color = '#475569'; e.currentTarget.style.borderColor = 'rgba(15, 23, 42, 0.1)'; }}
                          >
                            <VisibilityIcon style={{ fontSize: '0.95rem' }} />
                          </button>
                          {/* Contraseña (solo complemento360) */}
                          {isComplemento360 && (
                            <button
                              title={`Cambiar contraseña de ${user.username}`}
                              style={actionBtnStyle}
                              onClick={() => openPasswordDialog(user)}
                              onMouseEnter={(e) => { e.currentTarget.style.color = '#0284c7'; e.currentTarget.style.borderColor = 'rgba(2, 132, 199, 0.3)'; }}
                              onMouseLeave={(e) => { e.currentTarget.style.color = '#475569'; e.currentTarget.style.borderColor = 'rgba(15, 23, 42, 0.1)'; }}
                            >
                              <LockResetIcon style={{ fontSize: '0.95rem' }} />
                            </button>
                          )}
                          {/* Eliminar */}
                          <button
                            title="Eliminar usuario"
                            style={actionBtnStyle}
                            onClick={() => {
                              Swal.fire({
                                title: "¿Estás seguro?",
                                text: "¿Deseas eliminar este usuario?",
                                icon: "warning",
                                showCancelButton: true,
                                confirmButtonColor: "#D71920",
                                cancelButtonColor: "#64748b",
                                confirmButtonText: "Sí, eliminar",
                                cancelButtonText: "Cancelar",
                                allowOutsideClick: false,
                              }).then(async (result) => {
                                if (result.isConfirmed) {
                                  let actUsrToken = window.sessionStorage.getItem("localToken");
                                  let deleteResponse = await axios.delete(
                                    apiMethods.DELETE_USUARIO_ID + user.usrId,
                                    { headers: { Authorization: actUsrToken } }
                                  );
                                  if (deleteResponse.data.code == 0) {
                                    toast.success("Usuario eliminado correctamente");
                                    loadUsers();
                                  } else {
                                    toast.error(deleteResponse.data.message || "Error al eliminar usuario");
                                  }
                                }
                              });
                            }}
                            onMouseEnter={(e) => { e.currentTarget.style.color = '#D71920'; e.currentTarget.style.borderColor = 'rgba(203, 16, 22, 0.3)'; }}
                            onMouseLeave={(e) => { e.currentTarget.style.color = '#475569'; e.currentTarget.style.borderColor = 'rgba(15, 23, 42, 0.1)'; }}
                          >
                            <DeleteOutlineIcon style={{ fontSize: '0.95rem' }} />
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="3" style={{ textAlign: 'center', color: '#667085', padding: '3rem 1rem' }}>
                      {searchTerm ? 'No se encontraron usuarios con ese criterio de búsqueda.' : 'No se encontraron usuarios registrados.'}
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>

      {/* Modal Crear / Actualizar Usuario */}
      <Dialog
        open={props.createDialog}
        onClose={closeCreateDialog}
        fullWidth={true}
        maxWidth="sm"
        PaperProps={{
          sx: {
            borderRadius: '20px',
            background: 'rgba(255, 255, 255, 0.92)',
            backdropFilter: 'blur(20px)',
            boxShadow: '0 24px 48px rgba(15, 23, 42, 0.2)',
            border: '1px solid rgba(255, 255, 255, 0.9)'
          }
        }}>
        <DialogTitle sx={{ fontWeight: 700, fontSize: '1.2rem', color: '#101828', pb: 1 }}>
          {props.update ? "Actualizar usuario" : "Registrar Nuevo Usuario"}
        </DialogTitle>
        <DialogContent dividers sx={{ borderColor: '#EAECF0' }}>
          <form
            onSubmit={(e) => {
              formik.isValid ? createUser(e) : onError(e);
            }}>
            <div style={{ display: "flex", flexDirection: "column", gap: "1.25rem", paddingTop: "0.5rem" }}>
              <TextField
                required
                fullWidth
                label="Nombre de usuario"
                id="username"
                value={formik.values.username}
                onChange={formik.handleChange}
                size="small"
                InputProps={{ style: { borderRadius: '10px' } }}
              />
              {!props.update && (
                <TextField
                  required
                  fullWidth
                  label="Contraseña"
                  id="password"
                  type="password"
                  value={formik.values.password}
                  onChange={formik.handleChange}
                  size="small"
                  InputProps={{ style: { borderRadius: '10px' } }}
                />
              )}
              <FormControl fullWidth size="small">
                <InputLabel id="role-select-label">Rol</InputLabel>
                <Select
                  required
                  labelId="role-select-label"
                  label="Rol"
                  name="roleId"
                  id="roleId"
                  value={formik.values.roleId}
                  onChange={formik.handleChange}
                  sx={{ borderRadius: '10px' }}>
                  <MenuItem value="1">Administrador</MenuItem>
                  <MenuItem value="2">Usuario</MenuItem>
                </Select>
              </FormControl>
            </div>
          </form>
        </DialogContent>
        <DialogActions sx={{ padding: '1rem 1.5rem', gap: '0.5rem' }}>
          <button type="button" className="btn-mobilia-secondary" onClick={closeCreateDialog}>
            Cancelar
          </button>
          <button
            type="button"
            className="btn-mobilia-primary"
            onClick={props.update ? updateUser : createUser}>
            {props.update ? "Actualizar" : "Crear Usuario"}
          </button>
        </DialogActions>
      </Dialog>

      {/* Modal Cambiar Contraseña */}
      <Dialog
        open={passwordDialog.open}
        onClose={closePasswordDialog}
        fullWidth={true}
        maxWidth="xs"
        PaperProps={{
          sx: {
            borderRadius: '20px',
            background: 'rgba(255, 255, 255, 0.92)',
            backdropFilter: 'blur(20px)',
            boxShadow: '0 24px 48px rgba(15, 23, 42, 0.2)',
            border: '1px solid rgba(255, 255, 255, 0.9)'
          }
        }}>
        <DialogTitle sx={{ fontWeight: 700, fontSize: '1.15rem', color: '#101828', pb: 1 }}>
          Restablecer Contraseña
        </DialogTitle>
        <DialogContent dividers sx={{ borderColor: '#EAECF0' }}>
          <form onSubmit={handlePasswordChange}>
            <p style={{ fontSize: '0.85rem', color: '#64748b', margin: '0 0 1rem 0' }}>
              Asignar nueva contraseña para el usuario <strong>{passwordDialog.username}</strong>
            </p>
            <div style={{ display: "flex", flexDirection: "column", gap: "1rem" }}>
              <TextField
                required
                size="small"
                label="Nueva contraseña"
                type="password"
                value={passwordForm.password}
                onChange={(e) => setPasswordForm((p) => ({ ...p, password: e.target.value }))}
                helperText="Mínimo 8 caracteres"
                fullWidth
                InputProps={{ style: { borderRadius: '10px' } }}
              />
              <TextField
                required
                size="small"
                label="Confirmar contraseña"
                type="password"
                value={passwordForm.confirmPassword}
                onChange={(e) => setPasswordForm((p) => ({ ...p, confirmPassword: e.target.value }))}
                fullWidth
                InputProps={{ style: { borderRadius: '10px' } }}
              />
            </div>
          </form>
        </DialogContent>
        <DialogActions sx={{ padding: '1rem 1.5rem', gap: '0.5rem' }}>
          <button type="button" className="btn-mobilia-secondary" onClick={closePasswordDialog}>
            Cancelar
          </button>
          <button type="button" className="btn-mobilia-primary" onClick={handlePasswordChange}>
            Actualizar Clave
          </button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  ) : (
    <AccessDenied />
  );
};

export default Users;